import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

const useLogisticsPreferences = ({ storeId }) => {
  const { data, loading } = useFetch(() => configurationServices.getStoreLogisticsPreferences({ storeId }), {
    doInitialRequest: true,
  })

  return {
    deliveryMethods: data?.delivery_methods,
    fetchingLogisticsPreferences: loading,
  }
}

export default useLogisticsPreferences
